function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 30,
  rx: 15,
  fill: "current"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.0059 22.5889H13.7559V22.8389V24.999V25.249H14.0059H15.251H15.501V24.999V22.8389V22.5889H15.251H14.0059Z",
  fill: "white",
  stroke: "white",
  strokeWidth: 0.5
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M18.5425 21.5185L18.3402 21.6655L18.4872 21.8677L19.7574 23.6152L19.9043 23.8174L20.1066 23.6704L21.1139 22.9383L21.3161 22.7913L21.1691 22.5891L19.899 20.8416L19.752 20.6394L19.5498 20.7863L18.5425 21.5185Z",
  fill: "white",
  stroke: "white",
  strokeWidth: 0.5
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M21.5787 17.9931L21.5014 18.2308L21.7392 18.3081L23.7934 18.9755L24.0311 19.0528L24.1084 18.815L24.4931 17.6309L24.5704 17.3932L24.3326 17.3159L22.2784 16.6484L22.0406 16.5712L21.9634 16.8089L21.5787 17.9931Z",
  fill: "white",
  stroke: "white",
  strokeWidth: 0.5
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M21.7392 11.8521L21.5014 11.9293L21.5787 12.1671L21.9634 13.3512L22.0406 13.589L22.2784 13.5117L24.3326 12.8442L24.5704 12.767L24.4931 12.5292L24.1084 11.3451L24.0311 11.1074L23.7934 11.1846L21.7392 11.8521Z",
  fill: "white",
  stroke: "white",
  strokeWidth: 0.5
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M4.7642 12.5292L4.68695 12.7669L4.9247 12.8442L6.97894 13.5117L7.21669 13.5889L7.29394 13.3512L7.67869 12.167L7.75594 11.9293L7.51819 11.852L5.46395 11.1846L5.2262 11.1073L5.14895 11.3451L4.7642 12.5292Z",
  fill: "white",
  stroke: "white",
  strokeWidth: 0.5
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M4.9247 17.315L4.68695 17.3922L4.7642 17.63L5.14895 18.8141L5.2262 19.0518L5.46395 18.9746L7.51819 18.3071L7.75594 18.2299L7.67869 17.9921L7.29394 16.808L7.21669 16.5703L6.97894 16.6475L4.9247 17.315Z",
  fill: "white",
  stroke: "white",
  strokeWidth: 0.5
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M8.09269 22.5972L7.94571 22.7994L8.14794 22.9464L9.15524 23.6785L9.35747 23.8255L9.50445 23.6233L10.7746 21.8757L10.9216 21.6735L10.7193 21.5265L9.71203 20.7944L9.50981 20.6474L9.36282 20.8497L8.09269 22.5972Z",
  fill: "white",
  stroke: "white",
  strokeWidth: 0.5
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M18.074 11.1352C17.5765 10.6547 17.2486 10.0295 17.1349 9.36719H15.2524V13.4004H14.0073V9.36719H12.1271C12.0162 10.0268 11.6887 10.6507 11.1903 11.1301C10.204 12.0797 9.66404 13.3561 9.66997 14.724C9.68051 17.4091 11.873 19.6247 14.5573 19.663C14.5817 19.6634 14.6059 19.6636 14.6303 19.6636C15.9422 19.6636 17.176 19.1582 18.1116 18.2358C19.0648 17.2962 19.5897 16.0417 19.5897 14.7035C19.5897 13.3455 19.0514 12.0782 18.074 11.1352Z",
  fill: "white"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M17.0898 8.12242L17.0884 5.49791H15.2526V3.75H14.0075V5.49791H12.1699V8.12242H17.0898Z",
  fill: "white"
});

function SvgArtifficialLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtifficialLight);
export default __webpack_public_path__ + "static/media/artifficial_light.001e6046.svg";
export { ForwardRef as ReactComponent };